import CardTitleContainer from "@/src/mui-custom/card/card-title-container/card-title-container";
import CardTitleText from "@/src/mui-custom/card/card-title-text/card-title-text";
import CardTitleDivider from "@/src/mui-custom/card/card-title-divider/card-title-divider";
import CardBox from "@/src/mui-custom/card/card-box/card-box";
import CardBodyBox from "@/src/mui-custom/card/card-body-box/card-body-box";
import Tag from "@/src/_types/tag";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSidebarFlip} from '@fortawesome/pro-duotone-svg-icons';
import CustomTagCloud from "@/src/components/journal-site/home/journal-keywords/custom-tag-cloud/custom-tag-cloud";
import CardTitleBox from "@/src/mui-custom/card/card-title-box/card-title-box";
import Journal from "@/src/_types/journal";

const JournalKeywords = ({ journal }: { journal: Journal }) => {
    const data: Tag[] = journal.services?.keywords_cloud?.config.map((keyword: any) => ({
        value: keyword?.keyword,
        count: keyword?.count,
    }));

    return (
        <CardBox sx={{
            display: 'flex',
            justifyContent: 'center',
            gap: '.5rem',
            flexDirection: 'column',
            alignItems: 'center',
            paddingY: '1rem',
            paddingX: '.5rem',
            width: '100%',
        }}>
            <CardTitleContainer>
                <CardTitleBox>
                    <FontAwesomeIcon icon={faSidebarFlip} className={'icon'}/>
                    <CardTitleText variant={"h2"}>
                        Keywords
                    </CardTitleText>
                </CardTitleBox>
                <CardTitleDivider/>
            </CardTitleContainer>
            <CardBodyBox sx={{
                textAlign: 'center'
            }}>
                <CustomTagCloud
                    data={data}
                />
            </CardBodyBox>
        </CardBox>
    );
}

export default JournalKeywords;
